import { render, staticRenderFns } from "./blood.vue?vue&type=template&id=ce10b3c4&scoped=true&"
import script from "./blood.vue?vue&type=script&lang=js&"
export * from "./blood.vue?vue&type=script&lang=js&"
import style0 from "./blood.vue?vue&type=style&index=0&id=ce10b3c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10b3c4",
  null
  
)

export default component.exports